const navigation = [
  { name: "Locations", href: "/locations" },
  { name: "Cities", href: "/cities" },
  { name: "Offerings", href: "/offerings" },
  { name: "Discover", href: "/discover" },
  { name: "Contact", href: "/contact" },
];

export default navigation;
